<template>
  <div class="space-y-4" aria-hidden="true">
    <div v-for="index in 3" :key="index" class="border border-gray-200 rounded-md bg-white">
      <div class="flex items-center gap-2 px-3 py-2 border-b border-gray-200 bg-gray-50 rounded-t-md">
        <div class="h-4 w-4 rounded-md bg-gray-200 animate-pulse motion-reduce:animate-none"></div>
        <div class="h-4 w-24 rounded-md bg-gray-200 animate-pulse motion-reduce:animate-none"></div>
      </div>
      <div class="p-3 space-y-2">
        <div class="h-3 w-full rounded-md bg-gray-100 animate-pulse motion-reduce:animate-none"></div>
        <div class="h-3 w-5/6 rounded-md bg-gray-100 animate-pulse motion-reduce:animate-none"></div>
        <div class="h-3 w-2/3 rounded-md bg-gray-100 animate-pulse motion-reduce:animate-none"></div>
      </div>
    </div>
  </div>
</template>

<script>
// Forma de los bloques mientras carga el contenido de la lección (FE-051).
export default {
  name: "BlocksLoadingSkeleton",
}
</script>
